// extracted by mini-css-extract-plugin
export default {"container":"ImageModal_container__r5t62","img_container":"ImageModal_img_container__6CD6f","header":"ImageModal_header__SetYn"};